import styled from 'styled-components';

import { Box } from '@hivebrite/design-system/Box';

import IconErrorFile from 'hb-react/shared/icons/ErrorFile';

const NotFound = () => (
  <StyledWrapper>
    <StyledTitle mb={3}>{s__('Portfolio|File not found')}</StyledTitle>
    <StyledText mb={8}>
      {s__('Portfolio|Sorry, this file was not found')}
    </StyledText>
    <Box display="block" color="primary">
      <IconErrorFile height={120} width={120} />
    </Box>
  </StyledWrapper>
);

export default NotFound;

const StyledWrapper = styled(Box).attrs({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  width: '100%',
  height: { _: '200px', m: '290px', l: '230px', xl: '395px' },
  alignItems: 'center',
})``;

const StyledTitle = styled(Box).attrs({
  display: 'block',
  font: 'h3-semibold',
})``;

const StyledText = styled(Box).attrs({
  display: 'block',
  font: 'body-asphalt-italic',
})``;
